// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative Imports
import actions from '../../actions/actions';
import PropertyCount from './PropertyCount';
import propertyCountActions from '../../actions/propertyCount';
import userInfoActions from '../../actions/userInfo';
import helpActions from '../../actions/help';
import {isPPM, isSWSwitchIPM} from '../../utils/validate';
import {PC_ELIGIBILITY_INFO} from '../../utils/constants';
import {isUsSite} from '../../utils/validate';
import {validateCountOfProperty} from '../../utils/validate';

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        userType: get(state, 'app.userType', 'IPM'),
        translations: state.app.translations,
        ulxParams: state.app.ulxParams,
        numberOfProperty: get(state, 'propertyCount.numberOfProperty', ''),
        propertyCountError: get(state, 'propertyCount.propertyCountError', ''),
        enableContinueButton: get(state, 'propertyCount.enableContinueButton', false),
        basicInformation: get(state, 'basicInformation'),
        companyLocation: get(state, 'companyLocation'),
        userInfo: get(state, 'userInfoDetails.userInfoMetadata', {}),
        isSaveModalOpen: get(state, 'app.isSaveModalOpen', false),
        serviceError: get(state, 'propertyCount.serviceError', ''),
        propertyCount: get(state, 'propertyCount', {}),
        currency: get(state, 'reviewPage.accountDetails.currencySettings', ''),
        siteName: get(state, 'system.siteName'),
        listingMetadata: get(state, 'propertyCount.listingMetadata', {})
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
        propertyCountActions: bindActionCreators(propertyCountActions, dispatch),
        helpActions: bindActionCreators(helpActions, dispatch),
        userInfoActions: bindActionCreators(userInfoActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
export default class PropertyCountContainer extends React.Component {
    constructor(props) {
        super(props);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.handleContinueButtonClick = this.handleContinueButtonClick.bind(this);
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
        this.handlePropertyCountChange = this.handlePropertyCountChange.bind(this);
        this.triggerEdapEventOnFocus = this.triggerEdapEventOnFocus.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleSaveAndFinishOnClick = this.handleSaveAndFinishOnClick.bind(this);
        this.handleSaveModalClose = this.handleSaveModalClose.bind(this);
    }

    componentWillMount() {
        const {userType, publicUuid} = this.props;

        if (isPPM(userType)) {
            this.props.actions.enableLoadOverLay(true);
            this.props.propertyCountActions.getListingMetadata();
            this.props.actions.saveComponentPath('PROPERTY_COUNT');
            this.props.userInfoActions.getUserInfo();
            this.props.propertyCountActions.prePopulateLocalState(publicUuid);
        } else if (isSWSwitchIPM(userType)) {
            this.props.actions.saveComponentPath('PROPERTY_COUNT');
            this.props.propertyCountActions.prePopulateLocalState(publicUuid);
        } else {
            this.props.actions.enableLoadOverLay(false);
        }
    }

    componentDidMount() {
        // To support ULX - QC flow, pre-populate the propertyCount
        this.setPropertyCountByUlxParam();
    }

    setPropertyCountByUlxParam() {
        const {propertyCount} = this.props.ulxParams;

        if (propertyCount) {
            this.setPropertyCount(propertyCount);
        }
    }

    triggerEdapPageViewAction() {
        this.props.actions.triggerEdapPageView(this.props.publicUuid, 'Property Count Page');
    }

    handlePropertyCountChange(event) {
        if (validateCountOfProperty(event.target.value)) {
            event.preventDefault();
            this.setPropertyCount(event.target.value);
        }
    }

    setPropertyCount(propertyCount) {
        this.props.propertyCountActions.setPropertyCount(propertyCount);
        this.props.propertyCountActions.validatePropertyField(propertyCount);
    }

    sendIneligibleEmail(ineligibilityType) {
        const {basicInformation, companyLocation, numberOfProperty, userInfo, listingMetadata} = this.props;
        let helpFormData;
        if (isPPM(this.props.userType)) {
            const liveListingCount = listingMetadata.liveListingCount || 0;

            helpFormData = {
                data: {
                    firstName: userInfo.user.firstName,
                    lastName: userInfo.user.lastName,
                    emailAddress: userInfo.user.emailAddress,
                    companyName: userInfo.user.companyName,
                    companyLocation: '--',
                    propertyCount: liveListingCount + numberOfProperty
                }
            };
        } else {
            helpFormData = {
                data: {
                    firstName: basicInformation.firstName,
                    lastName: basicInformation.lastName,
                    emailAddress: basicInformation.email,
                    companyName: companyLocation.companyName,
                    companyLocation: companyLocation.companyCountryInfo.countryName,
                    propertyCount: (numberOfProperty) || 0,
                    vatStatus: companyLocation.vatChoice,
                    businessUnit: companyLocation.businessType
                }
            };
        }
        helpFormData.data.message = ineligibilityType;
        helpFormData.type = 'INELIGIBLE';
        this.props.helpActions.submitHelpForm(helpFormData);
    }

    handleContinueButtonClick() {
        this.props.actions.enableLoadOverLay(true);
        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Property count submit'
        }, {});
        const ineligibilityType = 'INVALID_PROPERTY_COUNT';

        if (isPPM(this.props.userType)) {
            const {listingMetadata, numberOfProperty} = this.props;
            const livePPBCount = listingMetadata.ppbListingCount || 0;
            const livePPSCount = listingMetadata.ppsListingCount || 0;
            const liveListingCount = listingMetadata.liveListingCount || 0;
            const totalPropertyCount = liveListingCount + numberOfProperty;

            const propertyCountInfo = {
                propertyCount: {
                    livePPBCount,
                    livePPSCount,
                    newPPBCount: numberOfProperty
                }
            };

            if (isUsSite(this.props.siteName) || totalPropertyCount >= PC_ELIGIBILITY_INFO.ppm.propertyCount) {
                this.props.propertyCountActions.updatePropertyCountInfo(propertyCountInfo);
            } else {
                this.sendIneligibleEmail(ineligibilityType);
                this.props.actions.showIneligibleForm(ineligibilityType);
            }
        } else if (isSWSwitchIPM(this.props.userType)) {
            const propertyCountInfo = {
                propertyCount: {
                    livePPBCount: 0,
                    livePPSCount: 0,
                    newPPBCount: this.props.numberOfProperty
                }
            };
            this.props.propertyCountActions.updatePropertyCountInfo(propertyCountInfo);
        } else if (!(isUsSite(this.props.siteName))) {
            if (this.props.numberOfProperty >= PC_ELIGIBILITY_INFO.ipm.other.propertyCount) {
                this.props.actions.changeAppState('CREATE_ACCOUNT');
            } else {
                this.sendIneligibleEmail(ineligibilityType);
                this.props.actions.showIneligibleForm(ineligibilityType);
            }
        } else if (this.props.numberOfProperty >= PC_ELIGIBILITY_INFO.ipm.homeaway_us.propertyCount) {
            this.props.actions.changeAppState('CREATE_ACCOUNT');
        } else {
            this.sendIneligibleEmail(ineligibilityType);
            this.props.actions.showIneligibleForm(ineligibilityType);
        }
    }

    handleBackButtonClick(event) {
        event.preventDefault();
        this.props.actions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });
        this.props.actions.changeAppState('COMPANY_LOCATION');
    }

    triggerEdapEventOnFocus(e) {
        this.props.actions.triggerEdapEvent('generic.event', {
            eventcategory: e.target.name,
            eventaction: `on Focus:${e.target.name}`
        });
    }

    handleAlertDismiss() {
        this.props.propertyCountActions.alertError('');
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value) {
            this.props.propertyCountActions.validatePropertyField('');
        }
    }

    handleSaveAndFinishOnClick() {
        const stateData = this.props.propertyCount;
        this.props.actions.saveComponentState('propertyCount', stateData);
        this.props.actions.showSaveAndFinishModal(true);
    }

    handleSaveModalClose() {
        this.props.actions.showSaveAndFinishModal(false);
    }

    render() {
        const {listingMetadata} = this.props;
        const liveListingCount = listingMetadata.liveListingCount || 0;

        return (
            <PropertyCount
                translations={this.props.translations}
                handlePropertyCountChange={this.handlePropertyCountChange}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                handleContinueButtonClick={this.handleContinueButtonClick}
                handleBackButtonClick={this.handleBackButtonClick}
                numberOfProperty={this.props.numberOfProperty}
                triggerEdapEvent={this.triggerEdapEvent}
                propertyCountError={this.props.propertyCountError}
                triggerEdapEventOnFocus={this.triggerEdapEventOnFocus}
                onPropertyCountBlur={this.showOnFieldBlur}
                enableContinueButton={this.props.enableContinueButton}
                userType={this.props.userType}
                liveListingCount={liveListingCount}
                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}

                handleSaveAndFinishOnClick={this.handleSaveAndFinishOnClick}
                isSaveModalOpen={this.props.isSaveModalOpen}
                handleSaveModalClose={this.handleSaveModalClose}
                siteName={this.props.siteName}
            />
        );
    }
}

PropertyCountContainer.propTypes = {
    siteName: PropTypes.string,
    publicUuid: PropTypes.string,
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    numberOfProperty: PropTypes.string,
    propertyCountError: PropTypes.string,
    enableContinueButton: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    userType: PropTypes.string,
    existingPropertyCount: PropTypes.number
};

PropertyCountContainer.defaultProps = {
    siteName: '',
    publicUuid: '-1',
    numberOfProperty: '',
    propertyCountError: '',
    enableContinueButton: false,
    userType: 'IPM',
    existingPropertyCount: 0
};
